import { RequestMethod } from '@angular/http';
import { DataServiceError } from '../../model/errors/service-error.model';

export interface DataValidator {
  validate(data: any, method: RequestMethod): any
}

export class DefaultDataValidator implements DataValidator {
  public validate(data: any, method: RequestMethod): any {
    if (typeof data === 'undefined' || data === null) {
      throw new DataServiceError();
    }
    return data;
  }
}

export class ReservationDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class ReservationV2DataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class AvailabilityV2DataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class HotelDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class ReservationRateRulesDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class ReservationStayPreferencesDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class AccountStayPreferencesDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class RateRuleDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class HotelExtraInfoDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class PointsEstimationDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class MemberDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class UserStatusDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class FeatureTogglesDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class EnrollmentDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class EmailUsageDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class AssociateDataValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}

export class TargetSystemValidator extends DefaultDataValidator {
  public validate(data: any, method: RequestMethod): any {
    return super.validate(data, method);
  }
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/validators/data.validators.ts